import type { ContentBlock as ContentBlockType } from '../../../shared/types'
import useHeaderContent from './useHeaderContent'
import styles from './HeaderContent.module.scss'
import { ContentBlock } from '../'
import { parentMeta } from '../ContentBlock/type'

interface HeaderContentType {
  parentMeta?: parentMeta
  filePath?: string
  contentBlock?: ContentBlockType
}

const HeaderContent = (props: HeaderContentType) => {
  const { parentMeta, contentBlock, filePath } = props

  const {} = useHeaderContent()

  return (
    <ContentBlock
      parentMeta={parentMeta}
      filePath={filePath}
      className={styles.headerContentRoot}
      contentBlock={contentBlock}
    ></ContentBlock>
  )
}

export default HeaderContent
